import React from 'react';
import ReactDOM from 'react-dom';
import AuthWrapper from './AuthWrapper';
import reportWebVitals from './reportWebVitals';

//router
import { BrowserRouter } from 'react-router-dom'
//store

import { Provider } from 'react-redux';
//reducer
import createStore from './store'

//scss
import "./HopeUI/assets/scss/hope-ui.scss"
import "./HopeUI/assets/scss/dark.scss"
import "./HopeUI/assets/scss/rtl.scss"
import "./HopeUI/assets/scss/custom.scss"
import "./HopeUI/assets/scss/customizer.scss"


ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Provider store={createStore()}>
        <AuthWrapper />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
